import { Link } from "react-router-dom";

const AUDIENCE = [
  { icon: "ri-vip-diamond-line", label: "HNI Investors" },
  { icon: "ri-earth-line", label: "NRI Investors" },
  { icon: "ri-briefcase-4-line", label: "Corporate Professionals" },
  { icon: "ri-store-2-line", label: "Business Owners" },
  { icon: "ri-hotel-line", label: "Hospitality Investors" },
  { icon: "ri-group-line", label: "Families Seeking Holiday Homes" },
  { icon: "ri-wallet-3-line", label: "Passive Income Seekers" },
];

export default function IdealFor() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-14 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-user-heart-line"></i> Ideal For
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
              Who Is This <span className="italic text-primary-700">Opportunity</span> For?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Whether you&apos;re a seasoned investor or a family looking for a meaningful
              lifestyle asset, there&apos;s a place for you at Nomad Livings.
            </p>

            <Link
              to="/why-invest"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
            >
              See If It Fits Your Goals
              <i className="ri-arrow-right-line"></i>
            </Link>

            <div className="flex flex-wrap gap-3 mt-8">
              {AUDIENCE.map((item) => (
                <span
                  key={item.label}
                  className="inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 text-sm font-semibold px-4 py-2.5 whitespace-nowrap"
                >
                  <i className={`${item.icon} text-base text-primary-700`}></i>
                  {item.label}
                </span>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20family%20enjoying%20morning%20coffee%20on%20the%20wooden%20deck%20of%20a%20luxury%20A-frame%20cabin%20overlooking%20a%20green%20valley%20and%20forest%2C%20warm%20sunlight%2C%20relaxed%20lifestyle%2C%20warm%20green%20and%20gold%20tones%2C%20premium%20lifestyle%20photography&width=1100&height=800&seq=ideal-nomad-1&orientation=landscape"
              alt="Family enjoying coffee on the deck of a luxury A-frame cabin"
              className="w-full h-72 md:h-[480px] object-cover object-top rounded-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}